import { render, staticRenderFns } from "./customerForm.vue?vue&type=template&id=33201e4a&scoped=true&"
import script from "./customerForm.vue?vue&type=script&lang=js&"
export * from "./customerForm.vue?vue&type=script&lang=js&"
import style0 from "./customerForm.vue?vue&type=style&index=0&id=33201e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33201e4a",
  null
  
)

export default component.exports